module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class='channel-icon-logo' fill=\"#FFA8CD\" d=\"M 165.823 0.863 L 128.039 0.863 C 128.039 36.288 109.023 68.031 80.135 90.701 L 68.772 99.776 L 68.772 0.863 L 29.506 0.863 L 29.506 199.247 L 68.772 199.247 L 68.772 100.904 L 133.725 199.247 L 181.63 199.247 L 119.153 105.158 C 147.549 81.636 166.071 45.069 165.823 0.863 Z\"  style=\"\"> \t</path>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/klarna.svg
// module id = 1320
// module chunks = 0